<template>
  <Card variant="outline" size="medium">
    <View direction="column" gap="md">
      <Text variant="h4">{{ title }}</Text>

      <ShowingRentersListItem
        v-for="renter in renters"
        :key="renter.id"
        :renter="renter"
        :property-id="propertyId"
        :status="status"
      />
    </View>
  </Card>
</template>

<script setup lang="ts">
import { AvatarStatus, Card, Text, View } from '@tallo/design-system';
import { ShowingRentersListItem } from '@tallo/investor/showing';
import { RenterDto } from '@tallo/renter';

defineProps<{ title: string; propertyId: string; renters: RenterDto[]; status: AvatarStatus }>();
</script>

<style scoped></style>
